import { Box, Container, Grid, GridSize } from '@mui/material';
import { AppState, DefaultProps } from '../../types/types';

interface FooterProps extends DefaultProps {
    appState: AppState,
}

function Footer(props: FooterProps) {
    let columnCount = 3;
    let impressum = props.appState?.customizing?.impressumSrc || 'https://www.rheinland-versicherungen.de/impressum/';
    let datenschutz = props.appState?.customizing?.datenschutzSrc || 'https://www.rheinland-versicherungen.de/datenschutz/digitales-postfach';
    let agb = props.appState?.customizing?.agbSrc || 'https://www.rheinland-versicherungen.de/nutzungsbedingungen/digitales-postfach';
    let kontaktdatenAendern = props.appState?.customizing?.kontaktdatenAendern;
    if (kontaktdatenAendern !== undefined) {
        columnCount++;
    }
 
    let faq = props.appState?.customizing?.faq;
    if (faq !== undefined) {
        columnCount++;
    }
    // Grid-Sizes bestimmen in Abhängigkeit der gerenderten Punkte.
    let sizeFirstCol: GridSize = 4;
    let sizeMiddleCol: GridSize = 2;
    let sizeLastCol: GridSize = 4;
    if (columnCount === 4) {
        sizeFirstCol = 3;
        sizeMiddleCol = 3;
        sizeLastCol = 3;
    }
    if (columnCount === 5) {
        sizeFirstCol = 3;
        sizeMiddleCol = 2;
        sizeLastCol = 3;
    }
    return (
        <Box sx={{
            backgroundColor: 'footer.main' || '#0069b4',
            color: 'footer.contrastText' || '#4444',
            bottom: 0,
            padding: 0,
            margin: 0,
            width: '100%',
            paddingBottom: '12px',
            marginBottom: '-24px',
            paddingTop: '14px',
            textAlign: 'center',
            overflowX: 'hidden',
            overflowY: 'hidden',
            fontSize: { xs: '0.8em', sm: '1em', md: '1em', lg: '1em' },
            "& a:hover": {
                textDecoration: 'underline',
            },
            "& a": {
                textDecoration: 'none',
                color: 'primary.contrastText' || '#4444'
            },
        }}>
            <Container maxWidth="lg">
                <Grid container spacing={0}>
                    <Grid item lg={sizeFirstCol} xs={3}>
                        <a href={impressum} target="_blank" rel="noreferrer">Impressum</a>
                    </Grid>
                    {(faq !== undefined) && <Grid item lg={sizeMiddleCol} xs={1}>
                        <a href={faq} target="_blank" rel="noreferrer">FAQ</a>
                    </Grid>}
                    <Grid item lg={sizeMiddleCol} xs={3}>
                        <a href={datenschutz} target="_blank" rel="noreferrer">Datenschutz</a>
                    </Grid>
                    <Grid item lg={sizeMiddleCol} xs={4}>
                        <a href={agb} target="_blank" rel="noreferrer">Nutzungsbedingungen</a>
                    </Grid>
                    {( kontaktdatenAendern !== undefined) && <Grid item lg={sizeLastCol} xs={2}>
                        <a href={kontaktdatenAendern} target="_blank" rel="noreferrer">Kontaktdaten ändern</a>
                    </Grid>}
                </Grid>
            </Container>
        </Box>
    );
}
export default Footer;